import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faLayerGroup,
  faUsers,
  faPlus,
  faGlobe,
  faStar,
  faRocket
} from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const EmptyLeaguesState = ({ onCreateLeague, onGlobalCompetition }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-dark-grey to-gray-700 p-6 text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
              <FontAwesomeIcon icon={faLayerGroup} className="text-white w-8 h-8" />
            </div>
            <h1 className="text-xl font-bold text-white mb-2">Welcome to Leagues</h1>
            <p className="text-white/80 text-sm">Start competing with friends or join the global competition</p>
          </div>
          
          {/* Content */}
          <div className="p-6">
            {/* Empty State Illustration */}
            <div className="text-center mb-6">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FontAwesomeIcon icon={faUsers} className="text-medium-grey w-8 h-8" />
              </div>
              <h2 className="text-lg font-bold text-dark-grey mb-2">No Leagues Yet</h2>
              <p className="text-medium-grey text-sm leading-relaxed">
                You haven't joined any leagues. Create your first league or jump into the global competition to start making predictions!
              </p>
            </div>
            
            {/* Action Buttons */}
            <div className="space-y-3">
              <Button
                variant="primary"
                size="lg"
                icon={faPlus}
                onClick={onCreateLeague}
                className="w-full justify-center"
              >
                Create New League
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                icon={faGlobe}
                onClick={onGlobalCompetition}
                className="w-full justify-center"
              >
                Join Global Competition
              </Button>
            </div>
          </div>
        </div>
        
        {/* Info Cards */}
        <div className="mt-6 space-y-3">
          {/* Create League Info */}
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-deep-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                <FontAwesomeIcon icon={faRocket} className="text-deep-red w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-dark-grey text-sm mb-1">Create Private League</h3>
                <p className="text-medium-grey text-xs leading-relaxed">
                  Start your own competition with custom rules and invite friends to compete against each other.
                </p>
              </div>
            </div>
          </div>
          
          {/* Global Competition Info */}
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <FontAwesomeIcon icon={faStar} className="text-blue-600 w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-dark-grey text-sm mb-1">Global Competition</h3>
                <p className="text-medium-grey text-xs leading-relaxed">
                  Compete against thousands of players worldwide in the ultimate prediction challenge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyLeaguesState; 